function updatePricePerDay() {
  // Function to handle the price per day calculation
  function calculatePricePerDay(pricePerItemText, daySupplyText, pricePerDayElement) {
    // Debugging: Log the elements and their texts
    console.log('Price Per Item Text:', pricePerItemText);
    console.log('Day Supply Text:', daySupplyText);

    // Get currency symbol, allowing for punctuation within the symbol
    let currencySymbolMatch = pricePerItemText.match(/^[^\d,]+/);
    let currencySymbol = currencySymbolMatch ? currencySymbolMatch[0].trim() : '';

    // Debugging: Log the extracted currency symbol
    console.log('Currency Symbol:', currencySymbol);

    // Remove currency symbol and any non-numeric characters except for commas and periods from price
    let numericPriceText = pricePerItemText.replace(currencySymbol, '').trim();
    numericPriceText = numericPriceText.replace(',','.');
    numericPriceText = numericPriceText.replace(/[^\d,.-]/g, '');

    // Ensure the first character is not a period or comma
    if (numericPriceText[0] === '.' || numericPriceText[0] === ',') {
      numericPriceText = numericPriceText.substring(1);
    }

    // Debugging: Log the cleaned numeric price text
    console.log('Numeric Price Text:', numericPriceText);

    // Parse text values to numbers
    // Handle commas as thousands separators
    numericPriceText = numericPriceText.replace(/,/g, '');
    let pricePerItem = parseFloat(numericPriceText);
    let daySupply = parseFloat(daySupplyText);

    // Debugging: Log the parsed values
    console.log('Parsed Price Per Item:', pricePerItem);
    console.log('Parsed Day Supply:', daySupply);

    // Check values are valid numbers
    if (!isNaN(pricePerItem) && !isNaN(daySupply) && daySupply > 0) {
      // Calculate price per day
      let pricePerDay = pricePerItem / daySupply;

      // Debugging: Log the calculated price per day
      console.log('Calculated Price Per Day:', pricePerDay);

      // Format price per day to 2 decimal places and update element with currency symbol
      let formattedPricePerDay = `${pricePerDay.toFixed(2)}`;
      if (currencySymbol.endsWith('.')) {
        pricePerDayElement.innerText = `${currencySymbol} ${formattedPricePerDay}`;
      } else {
        pricePerDayElement.innerText = `${currencySymbol}${formattedPricePerDay}`;
      }
    } else {
      // If values not valid, set price per day to "N/A"
      pricePerDayElement.innerText = `${currencySymbol}N/A`;

      // Debugging: Log the invalid values
      console.log('Invalid values detected:', { pricePerItem, daySupply });
    }
  }

  // Handle product page
  const productPagePricePerItemElement = document.querySelector(".pricePerItem");
  const productPageDaySupplyElement = document.querySelector(".daySupply");
  const productPagePricePerDayElement = document.querySelector(".pricePerDay");
  if (productPagePricePerItemElement && productPageDaySupplyElement && productPagePricePerDayElement) {
    calculatePricePerDay(productPagePricePerItemElement.innerText, productPageDaySupplyElement.innerText, productPagePricePerDayElement);
  }

  // Handle product cards (collection pages, carousels, etc.)
  const productCardPricePerItemElements = document.querySelectorAll(".product-card .pricePerItem");
  const productCardDaySupplyElements = document.querySelectorAll(".product-card .daySupply");
  const productCardPricePerDayElements = document.querySelectorAll(".product-card .pricePerDay");
  if (productCardPricePerItemElements.length === productCardDaySupplyElements.length && productCardDaySupplyElements.length === productCardPricePerDayElements.length) {
    productCardPricePerItemElements.forEach((pricePerItemElement, index) => {
      const daySupplyElement = productCardDaySupplyElements[index];
      const pricePerDayElement = productCardPricePerDayElements[index];
      calculatePricePerDay(pricePerItemElement.innerText, daySupplyElement.innerText, pricePerDayElement);
    });
  } else {
    console.error("Mismatched number of product card price per item, day supply, or price per day elements.");
  }

  // Handle featured product cards (home page, landing pages)
  const featuredProductCardPricePerItemElements = document.querySelectorAll(".featured-product-card .pricePerItem");
  const featuredProductCardDaySupplyElements = document.querySelectorAll(".featured-product-card .daySupply");
  const featuredProductCardPricePerDayElements = document.querySelectorAll(".featured-product-card .pricePerDay");
  if (featuredProductCardPricePerItemElements.length === featuredProductCardDaySupplyElements.length && featuredProductCardDaySupplyElements.length === featuredProductCardPricePerDayElements.length) {
    featuredProductCardPricePerItemElements.forEach((pricePerItemElement, index) => {
      const daySupplyElement = featuredProductCardDaySupplyElements[index];
      const pricePerDayElement = featuredProductCardPricePerDayElements[index];
      calculatePricePerDay(pricePerItemElement.innerText, daySupplyElement.innerText, pricePerDayElement);
    });
  } else {
    console.error("Mismatched number of featured product card price per item, day supply, or price per day elements.");
  }
}

// Call updatePricePerDay on initial page load
document.addEventListener("DOMContentLoaded", function() {
  updatePricePerDay();
});